import { StaticImageData } from 'next/image'

import {
  AboutUsImage,
  EventsImage,
  MembershipsImage,
} from 'Assets/Images/Sections/ThankYouLinksSection'

import { ABOUT_US, EVENTS, MEMBERSHIPS } from 'Constants/Paths'

enum ThankYouLinksCardId {
  UpcomingEvents = 'Upcoming Events',
  AboutEmajinGolf = 'About Emajin Golf',
  EmajinGolfHome = 'Emajin Golf Home',
}

type ThankYouLinksCard = {
  id: ThankYouLinksCardId
  image: StaticImageData
  title: string
  description: string
  link: string
  buttonCaption: string
}

export const THANK_YOU_LINKS_CARDS: ThankYouLinksCard[] = [
  {
    id: ThankYouLinksCardId.UpcomingEvents,
    image: EventsImage,
    title: 'Upcoming Events',
    description: 'It’s networking done the smart way.',
    link: EVENTS,
    buttonCaption: 'Events',
  },
  {
    id: ThankYouLinksCardId.AboutEmajinGolf,
    image: AboutUsImage,
    title: 'About Emajin Golf',
    description: 'Where golf, business & community combine.',
    link: ABOUT_US,
    buttonCaption: 'Learn more',
  },
  {
    id: ThankYouLinksCardId.EmajinGolfHome,
    image: MembershipsImage,
    title: 'Emajin Golf Home',
    description: 'Exceptional networking events, speakers and golf.',
    link: MEMBERSHIPS,
    buttonCaption: 'Head home',
  },
]
